// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'

import { Modal, ModalClose } from '@uswitch/spark'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void
}

export const BannerModal: React.FC<Props> = ({ onClose }) => (
  <Modal closeButton={onClose ? <ModalClose onClick={onClose} /> : undefined}>
    <p sx={{ variant: 'elements.modal.bannerText' }}>
      Based on the details you entered today, the lender has pre-approved you for this card. Please
      note acceptance is subject to further lender, fraud and ID checks.
    </p>
  </Modal>
)
